import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1","key":"svg-0"}]]

const IconArrowBack = createReactComponent('outline', 'arrow-back', 'ArrowBack', __iconNode);

export default IconArrowBack;